import { getPublicHttpClient } from '../axiosInstance'

export const loadUser = async (hash) => {
  const apiClient = getPublicHttpClient()
  const url = `/public/user/v1/${hash}`

  const response = await apiClient.get(url)
  return response.data
}

export const updatePassword = async (values) => {
  const apiClient = getPublicHttpClient()
  const { hash, ...form } = values
  const url = `/public/user/v1/form/${hash}`

  const response = await apiClient.post(url, form)
  return response.data
}
